<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">
        {{ $t('setting.cutOffAutomation.history.description') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end d-flex">
          <McButtonBack href="/setting/engine-off/" class="me-2" />
        </div>
      </div>
    </div>

    <div class="table-responsive mt-3 mc-history_engine-off">
      <McGrapqlTable
        :apiClient="query"
        :fields="fields"
        :searchable="true"
        :hasFilter="true"
        :withCard="true"
        :activeFilters="activeFilters"
        :hasCheckbox="false"
        :clientSidePagination="true"
      >
        <template #button-filter="{}">
          <div class="d-flex justify-content-between">
            <McInlineFilter
              :filterItems="filteredItems"
              :activeKeys="activeFilters['status']"
              @update:activeKeys="handleChangeActiveFilters([{ key: 'status', values: $event }])"
            />

            <ModalFilter
              :activeFilters="activeFilters"
              @handleChangeActiveFilters="handleChangeActiveFilters"
            />
          </div>
        </template>
        <template #cell(engineOffDate)="data">
          <div class="d-flex flex-column">
            <span>{{ momentDateShortMonth(data.item.createdOn) }}</span>
            <span class="text-muted">
              {{ momentTimeSeconds(data.item.createdOn) }} {{ getLabelTimezone() }}
            </span>
          </div>
        </template>
        <template #cell(engineOffStatus)="data">
          <span v-if="data.item.status === 'Success'" class="mc-status mc-status--green">
            {{ $t('global.success2') }}
          </span>
          <span v-else class="mc-status mc-status--red">{{ $t('global.failed') }}</span>
        </template>
        <template #cell(licensePlate)="data">
          {{ data.item.vehicle.licensePlate ?? '-' }}
        </template>
        <template #cell(engineOffGeolocation)="data">
          {{ data.item.geofenceName ?? '-' }}
        </template>
      </McGrapqlTable>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import McInlineFilter from '@/components/McInlineFilter'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import ModalFilter from '../components/history/ModalFilter.vue'
import getFields from '../lib/fields/history'
import filteredItems from '../lib/filter/history'
import { GET_CUT_OFF_ENGINE_HISTORY } from '@/services/api/setting/engineOff/engineOff'
import moment from 'moment'
moment.locale('id')

export default {
  page: {
    title: 'Engine Off Automation',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McGrapqlTable,
    McInlineFilter,
    ModalFilter,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      historyField: getFields(this),
      filteredItems,
      activeFilters: {
        period: [
          moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
          moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        ],
      },
      filter: [],
      selectedIds: [],
    }
  },
  computed: {
    title() {
      return this.$t('setting.cutOffAutomation.history.title')
    },
    items() {
      return [
        {
          text: this.$t('setting.list.fleetGroup.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.cutOffAutomation'),
          to: '/setting/engine-off',
        },
        {
          text: this.$t('setting.cutOffAutomation.history.title'),
        },
      ]
    },
    fields() {
      return this.historyField
    },
    query() {
      return {
        get: async (filter) => {
          const { pagination, ...filterWithoutPagination } = filter
          const activeFilters = { ...this.activeFilters }

          if (
            activeFilters.status &&
            Array.isArray(activeFilters.status) &&
            activeFilters.status.length > 0
          ) {
            activeFilters.status = activeFilters.status[0]
          }

          if (!activeFilters.periode) {
            activeFilters.period = [
              moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            ]
          }
          
          if (
            activeFilters.period &&
            Array.isArray(activeFilters.period) &&
            activeFilters.period.length === 2
          ) {
            activeFilters.startDate = moment(
              activeFilters.period[0].replace(/^\d+(?=\d{4})/, '')
            ).toISOString()
            activeFilters.endDate = moment(
              activeFilters.period[1].replace(/^\d+(?=\d{4})/, '')
            ).toISOString()
            delete activeFilters.period
          }

          const res = await this.$apollo.query({
            query: GET_CUT_OFF_ENGINE_HISTORY,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filterWithoutPagination,
                ...activeFilters,
              },
            },
          })

          const histories = res.data?.cutOffEngineHistories

          const transformHistories = {
            ...histories,
            cutOffEngineHistories: {
              data: histories.cutOffEngineHistories,
              pagination: {
                total: histories.cutOffEngineHistories.length,
                page: 1,
                show: 10,
              },
            },
          }

          return transformHistories.cutOffEngineHistories
        },
      }
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.historyField = getFields(this)
      },
      immediate: true,
    },
  },
  mounted() {
    this.track('View List Engine Off Automation History')
  },
  methods: {
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)

        if (
          filter.values === null ||
          filter.values === undefined ||
          filter.values === '' ||
          filter.values === false
        )
          return
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        this.$set(this.activeFilters, filter.key, filter.values)
      })

      this.filter = filters
    },
  },
}
</script>
